// extracted by mini-css-extract-plugin
export default {"wrapper":"Hash_wrapper__X8Aye"};